export const environment = {
  version: "v1.0",
  production: true,
  clientName: "Acustica Audio Cloud Processing",
  shopLink: "https://www.acustica-audio.com/shop/products/CLOUDPROCESSING",
  endpoints: {
    "Luigi.Service": "https://cloudprocessing.acustica-audio.com/service",
    "Luigi.Worker.Sevice": "https://cloudprocessing.acustica-audio.com/worker"
  },
  keycloack: {
    authority: 'https://auth.acustica-audio.com/auth/realms/acustica-audio'
  },
  taskConfiguration: {
    maxFilesPerTask: 50,
    maxTaskNameLength: 50,
    cloudUpload: true,
    providerName: "Amazon" //Amazon, Backblaze
  },
  syncConfiguration: {
    key: "LAST_CLIENT_SYNC",
    maxSyncTimeout: 60 * 60
  }
};
